
import React from 'react';

export function useBasicPlaceFormState() {
  // Basic info states
  const [name, setName] = React.useState('');
  const [placeType, setPlaceType] = React.useState<string>('');
  const [note, setNote] = React.useState('');
  const [url, setUrl] = React.useState('');
  const [photos, setPhotos] = React.useState<string[]>([]);
  const [photoInput, setPhotoInput] = React.useState('');
  const [priceRange, setPriceRange] = React.useState<string>('');
  const [requiresReservation, setRequiresReservation] = React.useState(false);
  const [cuisineType, setCuisineType] = React.useState('');
  const [amenities, setAmenities] = React.useState<string>('');
  const [accessibilityFeatures, setAccessibilityFeatures] = React.useState<string>('');
  const [bestTimeToVisit, setBestTimeToVisit] = React.useState('');
  const [tags, setTags] = React.useState<string>('');
  const [rating, setRating] = React.useState<string>('');
  const [address, setAddress] = React.useState('');
  const [city, setCity] = React.useState('');
  const [country, setCountry] = React.useState('');

  const resetBasicFormState = () => {
    setName('');
    setPlaceType('');
    setNote('');
    setUrl('');
    setPhotos([]);
    setPhotoInput('');
    setPriceRange('');
    setRequiresReservation(false);
    setCuisineType('');
    setAmenities('');
    setAccessibilityFeatures('');
    setBestTimeToVisit('');
    setTags('');
    setRating('');
    setAddress('');
    setCity('');
    setCountry('');
  };

  return {
    // Basic info
    name, setName,
    placeType, setPlaceType,
    note, setNote,
    url, setUrl,
    photos, setPhotos,
    photoInput, setPhotoInput,
    priceRange, setPriceRange,
    requiresReservation, setRequiresReservation,
    cuisineType, setCuisineType,
    amenities, setAmenities,
    accessibilityFeatures, setAccessibilityFeatures,
    bestTimeToVisit, setBestTimeToVisit,
    tags, setTags,
    rating, setRating,
    address, setAddress,
    city, setCity,
    country, setCountry,
    resetBasicFormState
  };
}
